import { useEffect } from "react"

// Maps the original stitches subtheme keys (kept unchanged so call sites
// don't need to change) onto the ported Tailwind subtheme classnames
// defined in tailwind.config.ts's colors.subthemes.
const SUBTHEME_CLASS = {
  editor: "theme-editor",
  white: "theme-white",
  offwhite: "theme-offwhite",
  black: "theme-black",
  grey: "theme-grey",
  blackHeader: "theme-black-header",
  yellowHeader: "theme-yellow-header",
} as const

export function useSubtheme(name: keyof typeof SUBTHEME_CLASS, active = true) {
  useEffect(() => {
    if (active) {
      const className = SUBTHEME_CLASS[name]
      document.body.classList.add(className)
      return () => {
        document.body.classList.remove(className)
      }
    }
  }, [name, active])
}
